module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_7.9aac58da.pdf";